var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3210_8342)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3210_8342)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62349 0.0631836L11.9766 1.04756C12.1899 1.09678 12.343 1.29092 12.343 1.50967C12.343 1.72842 12.1926 1.91982 11.9766 1.96904L7.60708 2.96162C7.20786 3.05186 6.79497 3.05186 6.39575 2.96162L2.80005 2.14404V4.13193L3.07896 5.39521C3.16372 5.7835 2.86841 6.15264 2.46919 6.15264C2.06997 6.15264 1.77193 5.7835 1.85943 5.39521L2.13833 4.13193V1.99639L2.02349 1.96904C1.81021 1.91982 1.65435 1.72568 1.65435 1.50693C1.65435 1.28818 1.80747 1.09678 2.02349 1.04756L6.37661 0.0631836C6.78677 -0.0243164 7.21333 -0.0243164 7.62349 0.0631836ZM7.00005 7.65107C8.95786 7.65107 10.5465 6.0624 10.5465 4.10459C10.5465 3.76553 10.4973 3.4374 10.4098 3.12295V3.12842C10.4098 3.12842 9.21216 4.10459 7.00005 4.10459C4.78794 4.10459 3.59028 3.12842 3.59028 3.12842V3.12295C3.50278 3.43467 3.45357 3.76553 3.45357 4.10459C3.45357 6.0624 5.04224 7.65107 7.00005 7.65107ZM12.2993 8.84053L13.4094 12.2038C13.6993 13.0897 13.0403 14.0003 12.1079 14.0003H1.8895C0.959816 14.0003 0.300831 13.0897 0.587941 12.2038L1.6981 8.84053C2.01255 7.88623 3.1063 7.43506 4.00044 7.8917C4.21919 8.00381 4.45708 8.10772 4.71958 8.20342L6.61177 10.0956C6.82505 10.3089 7.17232 10.3089 7.3856 10.0956L9.27778 8.20342C9.54028 8.10772 9.78091 8.00381 9.99693 7.8917C10.8938 7.43506 11.9848 7.88623 12.2993 8.84053ZM11.4106 10.8421C11.6075 10.8421 11.7688 10.6808 11.7688 10.4839C11.7688 10.2843 11.6075 10.1257 11.4106 10.1257H10.1008C9.90396 10.1257 9.74263 10.287 9.74263 10.4839C9.74263 10.6808 9.90396 10.8421 10.1008 10.8421H11.4106Z",
    fill: "#667085"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3210_8342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3210_8342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.e2bb1249f1f5730c815464a5597390ad.svg";
export { ForwardRef as ReactComponent };